// extracted by mini-css-extract-plugin
export default {"teachingGuide":"styles__teachingGuide___cpBMY","header":"styles__header___ZVYvE","body":"styles__body___QDMZ0"};